import { FC } from 'react'
import { InfoItem } from '../../common/infoItem'
import Typography from '@/ui/components/typography'

type TAssetInfoProps = {
    asset: TAsset
}

const AssetInfoMail: FC<TAssetInfoProps> = ({ asset }) => {
    const {
        mail_vendor: mailVendor,
        dmarc_message: dmarcMessage,
        dmarc_check_result: dmarcCheckResult,
        spf_error_description: spfErrorDescription,
        spoofing_result: spoofingResult,
    } = asset

    const hasData =
        mailVendor || dmarcCheckResult || spoofingResult || spfErrorDescription

    if (!hasData) {
        return null
    }

    return (
        <>
            {mailVendor && (
                <InfoItem title="Mail vendor">
                    <p data-testid="mail-vendor">{mailVendor}</p>
                </InfoItem>
            )}
            {dmarcCheckResult && (
                <div className="dmarc">
                    <Typography
                        variant="l-regular"
                        className="section-title text"
                    >
                        DMARC
                    </Typography>
                    {dmarcCheckResult && (
                        <InfoItem title="Message">
                            <p>{dmarcMessage}</p>
                        </InfoItem>
                    )}
                    {dmarcCheckResult && (
                        <InfoItem title="Check result">
                            <p>{dmarcCheckResult ? 'Success' : 'Failed'}</p>
                        </InfoItem>
                    )}
                </div>
            )}
            {(spoofingResult || spfErrorDescription) && (
                <div className="spoofing">
                    <Typography
                        variant="l-regular"
                        className="section-title text"
                    >
                        SPF
                    </Typography>
                    {spoofingResult && (
                        <InfoItem title="Spoofing result">
                            <p>{spoofingResult}</p>
                        </InfoItem>
                    )}

                    {spfErrorDescription && (
                        <InfoItem title="Error description">
                            <p>{spfErrorDescription}</p>
                        </InfoItem>
                    )}
                </div>
            )}
        </>
    )
}

export default AssetInfoMail
